import {Component, OnDestroy, OnInit, Renderer2, TemplateRef, Type} from '@angular/core';
import {ModalRef} from '../modal-ref';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
    contentType: 'template' | 'string' | 'component';
    content: string | TemplateRef<any> | Type<any>;
    context;

    constructor(
        private ref: ModalRef,
        private renderer: Renderer2) {
    }

    close() {
        this.ref.close(null);
    }

    ngOnInit() {
        this.content = this.ref.content;

        if (typeof this.content === 'string') {
            this.contentType = 'string';
        } else if (this.content instanceof TemplateRef) {
            this.contentType = 'template';
            this.context = {
                close: this.ref.close.bind(this.ref)
            };
        } else {
            this.contentType = 'component';
        }

        // add class to body to prevent scrolling in the background on mobile screen
        this.renderer.addClass(document.body, 'modal-open');
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, 'modal-open');
    }
}
